import { inject, Injectable } from "@angular/core";
import { Observable } from 'rxjs';
import { environment } from "../../../environments/environment";
import { HttpService } from "../../shared/services/http.service";


@Injectable({providedIn: 'root'})
export class TimeLinesService {
    private timeLinesDetails = `${environment.opbBackendHost}/api/admin/timeline/config/detail`; 
    private timeLinesSave = `${environment.opbBackendHost}/api/admin/timeline/config/save`; 
    private timeLinesList = `${environment.opbBackendHost}/api/admin/timeline/list`; 
    private timeLinesUpdate = `${environment.opbBackendHost}/api/admin/timeline/update`;
    private futureIterationUrl = `${environment.opbBackendHost}/api/admin/timeline/add/future/iteration`; 
    

    httpService=inject(HttpService);


    getTimeLinesDetails(data: any): Observable<any> {
        return this.httpService.post(this.timeLinesDetails,data);
    }

    saveTimeLines(data: any): Observable<any> {
        return this.httpService.post(this.timeLinesSave,data);
    }

    getTimeLines(data: any): Observable<any> {
        return this.httpService.post(this.timeLinesList,data);
    }

    updateTimeLines(data: any): Observable<any> {
        return this.httpService.post(this.timeLinesUpdate,data);
    }


    futureIterationTimeLines(data: any): Observable<any> {
        return this.httpService.post(this.futureIterationUrl,data);
    }


}